export default {
  department: {
    key: 'department',
    name: '组织',
    type: 'field',
  },
  online_agent: {
    key: 'online_agent',
    name: '在线代理商个数',
    sortable: true,
    filterable: false,
    type: 'field',
    minWidth: 180,
  },
  avg_cost_online_agent: {
    key: 'avg_cost_online_agent',
    name: '在线代理商平均消耗(元)',
    sortable: true,
    filterable: false,
    type: 'field',
    minWidth: 220,
  },
  online_adv: {
    key: 'online_adv',
    name: '在线广告主个数',
    sortable: true,
    filterable: false,
    type: 'field',
    minWidth: 180,
  },
  avg_cost_online_adv: {
    key: 'avg_cost_online_adv',
    name: '在线广告主平均消耗(元)',
    sortable: true,
    filterable: false,
    type: 'field',
    minWidth: 220,
  },
  date: {
    key: 'date',
    name: '时间',
    type: 'field',
  },
  region: {
    key: 'region',
    name: '大区',
    type: 'field',
    branches: [
      {
        key: 'region_id',
        name: '大区ID',
        parent: 'region',
      },
      {
        key: 'region_name',
        name: '大区',
        parent: 'region',
      },
    ],
  },
  agent: {
    key: 'agent',
    name: '代理商',
    type: 'field',
    branches: [
      {
        key: 'agent_id',
        name: '代理商ID',
        parent: 'agent',
      },
      {
        key: 'agent_name',
        name: '代理商',
        parent: 'agent',
      },
      {
        key: 'agent_company',
        name: '代理商公司名称',
        parent: 'agent',
      },
    ],
  },
  agent_id: {
    key: 'agent_id',
    name: '代理商ID',
  },
  agent_name: {
    key: 'agent_name',
    name: '代理商',
  },
  agent_company: {
    key: 'agent_company',
    name: '代理商公司名称',
  },
  agent_type: {
    key: 'agent_type',
    name: '代理商类型',
    type: 'field',
  },
  account: {
    key: 'account',
    name: '广告主',
    type: 'field',
    branches: [
      {
        key: 'account_id',
        name: '广告主ID',
        parent: 'account',
      },
      {
        key: 'account_name',
        name: '广告主名称',
        parent: 'account',
      },
      {
        key: 'account_company',
        name: '广告主公司名称',
        parent: 'account',
      },
    ],
  },
  account_id: {
    key: 'account_id',
    name: '广告主ID',
  },
  account_name: {
    key: 'account_name',
    name: '广告主',
  },
  account_company: {
    key: 'account_company',
    name: '广告主公司名称',
  },
  account_type: {
    key: 'account_type',
    name: '广告主类型',
    type: 'field',
  },
  media_type: {
    key: 'media_type',
    name: '媒体类型',
    type: 'field',
  },
  adslot_type: {
    key: 'adslot_type',
    name: '栏位类型',
    type: 'field',
  },
  idea_type: {
    key: 'idea_type',
    name: '创意类型',
    type: 'field',
  },
  is_ocpc: {
    key: 'is_ocpc',
    name: '是否开启OCPC',
    type: 'field',
  },
  sale: {
    key: 'sale',
    name: '渠道销售',
    type: 'field',
    branches: [
      {
        key: 'sale_id',
        name: '渠道销售ID',
        parent: 'sale',
      },
      {
        key: 'sale_name',
        name: '渠道销售',
        parent: 'sale',
      },
    ],
  },
  sale_id:{
    key: 'sale_id',
    name: '渠道销售ID',
  },
  sale_name:{
    key: 'sale_name',
    name: '渠道销售',
  },
  direct_sale: {
    key: 'direct_sale',
    name: '直客销售',
    type: 'field',
    branches: [
      {
        key: 'direct_sales_id',
        name: '直客销售ID',
        parent: 'direct_sale',
      },
      {
        key: 'direct_sales_name',
        name: '直客销售',
        parent: 'direct_sale',
      },
    ],
  },
  direct_sale2: {
    key: 'direct_sale2',
    name: '所属',
    type: 'field',
    branches: [
      {
        key: 'direct_sales_id',
        name: '所属ID',
        parent: 'direct_sale',
      },
      {
        key: 'direct_sales_name',
        name: '所属',
        parent: 'direct_sale',
      },
    ],
  },
  direct_sales_id: {
    key: 'direct_sales_id',
    name: '所属ID',
  },
  direct_sales_name: {
    key: 'direct_sales_name',
    name: '所属',
  },
  product: {
    key: 'product',
    name: '产品名称',
    type: 'field',
    branches: [
      {
        key: 'product_id',
        name: '产品ID',
        parent: 'product',
      },
      {
        key: 'product_name',
        name: '产品名称',
        parent: 'product',
      },
    ],
  },
  product_id: {
    key: 'product_id',
    name: '产品ID',
  },
  product_name:{
    key: 'product_name',
    name: '产品名称',
  },
  app_marketing_type: {
    key: 'app_marketing_type',
    name: '营销场景',
    type: 'field',
  },
  category: {
    key: 'category',
    name: '行业分级',
    type: 'field',
    branches: [
      {
        key: 'category_one',
        name: '一级',
        parent: 'category',
      },
      {
        key: 'category_two',
        name: '二级',
        parent: 'category',
      },
      {
        key: 'category_three',
        name: '三级',
        parent: 'category',
      },
    ],
  },
  category_one: {
    key: 'category_one',
    name: '一级行业',
  },
  category_two: {
    key: 'category_two',
    name: '二级行业',
  },
  category_three: {
    key: 'category_three',
    name: '三级行业',
  },

  cr: {
    key: 'cr',
    name: '点击率',
    sortable: true,
    filterable: false,
    type: 'field',
  },

  cc: {
    key: 'cc',
    name: '点击单价(元)',
    sortable: true,
    filterable: false,
    type: 'field',
  },

  acp: {
    key: 'acp',
    name: '点击单价(元)',
    sortable: true,
    filterable: false,
    type: 'field',
    minWidth: 180,
  },

  ecpm: {
    key: 'ecpm',
    name: '千次展现消费(元)',
    sortable: true,
    filterable: false,
    type: 'field',
  },

  cpm: {
    key: 'cpm',
    name: '千次展现消费(元)',
    sortable: true,
    filterable: false,
    type: 'field',
    minWidth: 180,
  },

  list_ctr: {
    key: 'list_ctr',
    name: '列表页CTR',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  detail_ctr: {
    key: 'detail_ctr',
    name: '详情页CTR',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  list_acp: {
    key: 'list_acp',
    name: '列表页ACP',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  detail_acp: {
    key: 'detail_acp',
    name: '详情页ACP',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  list_ecpm: {
    key: 'list_ecpm',
    name: '列表页ECPM',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  detail_ecpm: {
    key: 'detail_ecpm',
    name: '详情页ECPM',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  cpa_given: {
    key: 'cpa_given',
    name: 'CPA Given',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  cvr: {
    key: 'cvr',
    name: '浅层CVR',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  deep_cvr: {
    key: 'deep_cvr',
    name: '深层CVR',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  cpa: {
    key: 'cpa',
    name: '浅层CPA',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  deep_cpa: {
    key: 'deep_cpa',
    name: '深层CPA',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  api_app_active_cost: {
    key: 'api_app_active_cost',
    name: '激活成本',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  api_app_register_cost: {
    key: 'api_app_register_cost',
    name: '注册成本',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  api_app_lahuo_cost: {
    key: 'api_app_lahuo_cost',
    name: '首活成本',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  cvr_keyaction_num: {
    key: 'cvr_keyaction_num',
    name: '关键行为数',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  api_app_keyaction_cost: {
    key: 'api_app_keyaction_cost',
    name: '关键行为成本',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  api_app_pay_cost: {
    key: 'api_app_pay_cost',
    name: '付费成本',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  api_app_retention_active_rate: {
    key: 'api_app_retention_active_rate',
    name: '次留率（激活）',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  api_app_retention_register_rate: {
    key: 'api_app_retention_register_rate',
    name: '次留率（注册）',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  api_app_retention_lahuo_rate: {
    key: 'api_app_retention_lahuo_rate',
    name: '次留率（首活）',
    sortable: true,
    filterable: false,
    type: 'field',
  },

  request: {
    key: 'request',
    name: '请求数',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  served_request: {
    key: 'served_request',
    name: '有效请求数',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  cost_cash: {
    key: 'cost_cash',
    name: '现金消耗(元)',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  impression_total: {
    key: 'impression_total',
    name: '展现数(次)',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  sale_type: {
    key: 'sale_type',
    name: '预算类型',
    sortable: false,
    filterable: false,
    type: 'field',
  },
  budget_name: {
    key: 'budget_name',
    name: '聚合名称',
    sortable: false,
    filterable: false,
    type: 'field',
  },
  customer_cate: {
    key: 'customer_cate',
    name: '客户类目',
    sortable: false,
    filterable: false,
    type: 'field',
  },
  product_series: {
    key: 'product_series',
    name: '产品系',
    sortable: false,
    filterable: false,
    type: 'field',
  },
  product_series_id: {
    key: 'product_series_id',
    name: '产品系id',
    sortable: false,
    filterable: false,
    type: 'field',
  },
  product_series_name: {
    key: 'product_series_name',
    name: '产品系',
    sortable: false,
    filterable: false,
    type: 'field',
  },
  task_name: {
    key: 'task_name',
    name: '任务名称',
    sortable: false,
    filterable: false,
    type: 'field',
  },
  click_total: {
    key: 'click_total',
    name: '点击数(次)',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  cost_total: {
    key: 'cost_total',
    name: '总消耗(元)',
    sortable: true,
    filterable: true,
    type: 'field',
  },
  cost_coupon: {
    key: 'cost_coupon',
    name: '优惠券消耗(元)',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  new_accounts_num: {
    key: 'new_accounts_num',
    name: '新开广告主数',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  new_account_cost: {
    key: 'new_account_cost',
    name: '新开广告主总消耗',
    sortable: true,
    filterable: false,
    type: 'field',
    minWidth: 180,
  },
  put_plans_num: {
    key: 'put_plans_num',
    name: '在投计划数',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  put_ideas_num: {
    key: 'put_ideas_num',
    name: '在投创意数',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  new_ideas_num: {
    key: 'new_ideas_num',
    name: '新增创意数',
    type: 'field',
  },
  served_account_num: {
    key: 'served_account_num',
    name: '有效账户数',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  new_account_num: {
    key: 'new_account_num',
    name: '新增账户数',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  new_account_cost_num: {
    key: 'new_account_cost_num',
    name: '新增有消耗账户数',
    info: '筛选时间内创建且当日有消耗的账户数',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  agent_num: {
    key: 'agent_num',
    name: '有效代理商数',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  plan_num: {
    key: 'plan_num',
    name: '消费计划数',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  unit_num: {
    key: 'unit_num',
    name: '消费单元数',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  unit: {
    key: 'unit',
    name: '单元',
    type: 'field',
  },
  idea_num: {
    key: 'idea_num',
    name: '消费创意数',
    sortable: true,
    filterable: false,
    type: 'field',
  },
  gain: {
    key: 'gain',
    name: '涨幅数据',
    filterable: false,
    type: 'field',
  },
  ctr: {
    key: 'ctr',
    name: 'CTR',
    sortable: true,
    filterable: false,
    type: 'field',
  },

  // filled_rate: {
  //   key: 'filled_rate',
  //   name: '填充率',
  //   sortable: true,
  //   filterable: false,
  //   type: 'field',
  // },
};
